import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { XCircle, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentCancelPage() {
  const { i18n } = useTranslation();
  const isFrench = i18n.language === 'fr';

  return (
    <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-[#E2725B]/20 flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-[#E2725B]" />
        </div>
        <h1 className="font-heading text-2xl font-semibold text-[#2D2D2D] mb-4">
          {isFrench ? "Paiement annulé" : "Payment cancelled"}
        </h1>
        <p className="text-[#5C5C5C] mb-8">
          {isFrench 
            ? "Vous avez annulé le paiement. Vous pouvez réessayer à tout moment."
            : "You cancelled the payment. You can try again anytime."}
        </p>
        <div className="space-y-4">
          <Link to="/premium">
            <Button className="w-full rounded-full bg-[#2F4F4F] hover:bg-[#2F4F4F]/90 text-white h-12">
              {isFrench ? "Réessayer" : "Try again"}
            </Button>
          </Link>
          <Link to="/">
            <Button variant="outline" className="w-full rounded-full border-gray-200 h-12">
              <ArrowLeft className="w-4 h-4 mr-2" />
              {isFrench ? "Retour à l'accueil" : "Back to home"}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
